const routes = {
  '/': 'Main',
  '/login': 'Login',
  '/register': 'Sign Up',
  '/reset/:token': 'Reset Password',
  '/account/profile': 'Profile',
  '/dashboard': 'Dashboard',
  '/components': 'Components',
  '/charts': 'Charts',
  '/components/buttons': 'Buttons',
  '/components/social-buttons': 'Social Buttons',
  '/components/cards': 'Cards',
  '/components/forms': 'Forms',
  '/components/modals': 'Modals',
  '/components/switches': 'Switches',
  '/components/tables': 'Tables',
  '/components/tabs': 'Tabs',
  '/icons': 'Icons',
  '/icons/font-awesome': 'Font Awesome',
  '/icons/simple-line-icons': 'Simple Line Icons',
  '/users': 'Users',
  '/users/list': 'List',
  '/users/new': 'New',
  '/users/view/:id/:hotelid': 'View',
  '/surveys': 'Surveys',
  '/surveys/list': 'List',
  '/surveys/view/:id': 'View',
  '/surveys/new': 'New',
  '/employees': 'Employees',
  '/employees/list': 'List',
  '/employees/view/:id': 'View',
  '/employees/new': 'New',
  '/employee-groups': 'Employee Groups',
  '/employee-groups/list': 'List',
  '/employee-groups/view/:id': 'View',
  '/employee-groups/new': 'New',
  '/my-surveys': 'My Surveys',
  '/my-surveys/view/:id/:hotelid': 'View',
  '/support': 'Support',
  '/widgets': 'Widgets'
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js